<template>
  <div class="ng-content-wrap">
    <NgongVegBanner />
    <div class="ng-block-head ng-block-head-lg">
      <div class="ng-block-head-sub d-print-none">
        <router-link to="/orders" class="back-to">
          <em class="icon ni ni-chevron-left-c mr-1"></em>
          <span>Back To Orders Input</span>
        </router-link>
      </div>
      <div class="ng-block-between-md g-4">
        <div class="ng-block-head-content">
          <h3 class="ng-block-title fw-normal">
            {{ $route.meta.title }}(All Customers)
          </h3>
          <div class="ng-block-des">
            <h6>
              For Week
              {{GetWeek(start)}}(
              <b>
                {{ fD(start, "E, do MMM") }}
              </b>
              -
              <b> {{ fD(end, "E, do MMM") }} </b>)
            </h6>
          </div>
        </div>
        <div class="ng-block-head-content">
          <ul class="ng-block-tools gx-3 d-print-none">
            <li>
              <a
                href="#pickDates"
                data-toggle="modal"
                class="btn btn-white btn-dim btn-outline-primary"
              >
                <em class="icon ni ni-calendar"></em>
                <span>
                  Week
                  <span class="d-none d-sm-inline-block">
                    {{GetWeek(start)}}
                  </span>
                </span>
              </a>
              <div class="modal fade" tabindex="-1" id="pickDates">
                <div class="modal-dialog" role="document">
                  <div class="modal-content justify-content-center">
                    <button
                      id="hideNewForm"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em class="icon ni ni-cross text-white"></em>
                    </button>

                    <div class="modal-header bg-primary">
                      <h5 class="modal-title text-white">Select Start Date</h5>
                    </div>

                    <div class="modal-body row justify-content-center">
                      <div
                        class="col-md-7 justify-content-center text-center mb-1"
                      >
                        <v-date-picker v-model="start" />
                      </div>
                      <div class="col-md-5 text-center">
                        <h5>Starting on</h5>
                        <p>
                          {{ fD(start) }}
                        </p>

                        <h5>Ending on</h5>
                        <p>
                          {{ fD(end) }}
                        </p>

                        <button
                          class="btn btn-outline-primary float-right"
                          data-dismiss="modal"
                        >
                          <span> Use Selected Week </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="ng-block">
      <div class="card card-bordered loading" v-if="processing">
        <div class="justify-content-center text-center">
          <div class="spinner-grow text-primary m-3" role="status">
            <span class="sr-only">Processing Data...</span>
          </div>
          <h6 class="mb-4">Processing Data...</h6>
        </div>
      </div>

      <div class="card card-bordered" v-else>
        <div class="card-content">
          <table class="table table-tranx table-bordered">
            <thead class="tb-tnx-head">
              <tr class="tb-tnx-item">
                <th class="tb-tnx-info">Product</th>
                <th
                  v-for="(d, i) in getDates(start)"
                  :key="i"
                  class="text-center align-middle"
                >
                  {{ fD(new Date(d), "E, do") }}
                </th>
                <th class="text-center align-middle">Total</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(p, i) in varieties" :key="i">
                <tr class="tb-tnx-item" :id="p.id" v-if="isFilled(p.id)">
                  <td class="tb-tnx-info align-middle">
                    <div class="tb-tnx-desc">
                      <span class="title">
                        {{ p.name }}
                      </span>
                    </div>
                  </td>
                  <td
                    v-for="(d, i) in getDates(start)"
                    :key="i"
                    class="text-center"
                  >
                    <template v-if="form[d]">
                      <div class="form-control-wrap">
                        {{
                          form[d][p.id].toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          })
                        }}
                      </div>
                    </template>
                  </td>
                  <td class="text-center align-middle">
                    {{
                      getPackageSum(p.id).toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                </tr>
              </template>
            </tbody>

            <tfoot class="tb-tnx-head d-print-none">
              <tr class="tb-tnx-item">
                <th class="tb-tnx-info align-middle">
                  <h6 class="text-left">Daily Summaries</h6>
                </th>
                <th
                  v-for="(d, i) in getDates(start)"
                  :key="i"
                  class="text-center align-middle"
                >
                  <router-link
                    :to="`/reports/day/${d}`"
                    class="btn btn-outline-light btn-sm"
                  >
                    {{ fD(new Date(d), "EEEE") }}
                  </router-link>
                </th>
                <th></th>
              </tr>
            </tfoot>
          </table>
        </div>

        <!-- <div class="alert alert-warning text-center" v-else>
          <h5>
            <em class="icon ni ni-alert text-warning"></em>
          </h5>
          Please select a customer to set orders for.
        </div> -->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import http from "../../../../../common/services/http";
import {computed, defineComponent, onMounted, reactive, ref, watch,} from "vue";
import moment from "moment";
import {format} from "date-fns";
import NgongVegBanner from "@/components/NgongVegBanner.vue";

export default defineComponent({
  components: {NgongVegBanner},
  props: {
    day: {
      type: String,
    },
  },
  setup(props) {
    const form = ref({});

    const varieties = ref([]);

    const search = ref("");
    const variety = reactive({
      name: "",
      code: "",
    });

    const orders = ref([]);

    const agents = ref([]);
    const agent_id = ref(0);

    const customers = ref([]);
    const user_id = ref(0);
    const customer = computed(() => {
      return (
        customers.value?.find((c: any) => c.id == user_id.value) || {
          contact: { currency: "euro" },
        }
      );
    });

    const processing = ref(false);
    const created = ref(false);
    const updated = ref(false);

    function friday() {
      const date = new Date();
      const last = new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000);

      return date.getDay() < 5
        ? new Date(last.setDate(last.getDate() - (last.getDay() - 1) + 4))
        : new Date(date.setDate(date.getDate() - (date.getDay() - 1) + 4));
    }

    const s = props.day ? new Date(props.day) : friday();
    const start = ref(s);
    const end = computed(
      () => new Date(new Date(start.value).getTime() + 6 * 24 * 60 * 60 * 1000)
    );

    function getDates(s: any) {
      const e = new Date(new Date(s).getTime() + 6 * 24 * 60 * 60 * 1000);

      const dates = [];
      let currentDate = moment(s);
      const eDate = moment(e);
      while (currentDate <= eDate) {
        dates.push(moment(currentDate).format("YYYY-MM-DD"));
        currentDate = moment(currentDate).add(1, "days");
      }

      return dates;
    }

    function fD(d: any, f = "PPPP") {
      return format(d, f);
    }

    function fetchAgents() {
      processing.value = true;
      http.get(`/api/users?role=agent&fetch=all`).then((res) => {
        agents.value = res.data;
        processing.value = false;
      });
    }

    function fetchCustomers() {
      processing.value = true;
      http.get(`/api/users?role=customer&fetch=all`).then((res) => {
        customers.value = res.data;
        processing.value = false;
      });
    }

    async function fetchOrders() {
      const res = await http.get(
        `/api/week-variety-orders?start=${fD(
          start.value,
          "yyyy-MM-dd"
        )}&end=${fD(end.value, "yyyy-MM-dd")}`
      );
      orders.value = res.data;

      return res.data;
    }

    function fetchVarieties() {
      processing.value = true;

      fetchOrders().then((os: any) => {
        http.get(`/api/varieties?fetch=all`).then((res) => {
          varieties.value = res.data;

          form.value = os;

          processing.value = false;
        });
      });
    }

    function searchVarieties() {
      fetchOrders().then((os: any) => {
        http.get(`/api/varieties?s=${search.value}&fetch=all`).then((res) => {
          const a = res.data.data;
          varieties.value = a;

          const dates = getDates(start.value);

          form.value = dates.reduce((o, d) => {
            const order: any = os.find((or: any) => or.date == d);

            return {
              ...o,
              [d]: a.reduce(
                (r: any, p: any) => ({
                  ...r,
                  [p.id]: (order?.quantities as any)[p.id] || 0,
                }),
                {}
              ),
            };
          }, {});
        });
      });
    }

    function getPackageSum(p: any) {
        const data = Object.values(form.value);

        return data.reduce((o: any, n: any) => {
          return o + parseFloat(n[p]);
        }, 0);
    }

    function getCurrency() {
      if (customer.value?.contact?.currency == "euro") {
        return "€";
      } else if (customer.value?.contact?.currency == "pound") {
        return "£";
      } else if (customer.value?.contact?.currency == "dollar") {
        return "$";
      } else if (customer.value?.contact?.currency == "shilling") {
        return "KSh";
      }
    }

    function isFilled(p: any) {
      const filled = Object.values(form.value).filter((d: any) => {
        return Number(d[p]) > 0;
      });

      return filled.length > 0;
    }

    onMounted(() => {
      // fetchAgents();
      // fetchCustomers();
      fetchVarieties();
    });

    watch(
      () => start.value,
      (v: any) => {
        fetchVarieties();
      }
    );

    function updateForm() {
      fetchVarieties();
    }

    return {
      fetchVarieties,
      processing,
      search,
      searchVarieties,
      varieties,
      created,
      variety,
      fD,
      getDates,
      start,
      end,
      form,
      customers,
      customer,
      user_id,
      updateForm,
      getPackageSum,
      getCurrency,
      orders,
      isFilled,
    };
  },
});
</script>
